import React, { useState, useEffect } from 'react';
import AgeVerification from './components/AgeVerification';
import StoreLocator from './components/StoreLocator';
import './styles/App.css';

function App() {
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    // Check if user was previously verified
    const verified = localStorage.getItem('ageVerified');
    if (verified === 'true') {
      setIsVerified(true);
    }
  }, []);

  const handleVerification = () => {
    localStorage.setItem('ageVerified', 'true');
    setIsVerified(true);
  };

  if (!isVerified) {
    return <AgeVerification onVerify={handleVerification} />;
  }

  return <StoreLocator />;
}

export default App;






